import type { ReactElement } from "react";
import { useSofortPopup } from "@kundeninfo/ui";

/**
 * Der Anlass einer Version in der Versionstabelle (477 b): höchstens zwei Zeilen (line-clamp, AngebotDetail.css), der
 * volle Text im Sofort-Popup statt `title` (Review 28 K2) — ein langer Anlass streckt die Zeile nicht und schiebt die
 * Aktionen nicht aus der Tabelle (Sichtprobe Task 29). Ohne Text bleibt die Zelle leer und ohne Popup.
 */
export function VersionNote(p: { text: string }): ReactElement | null {
  const popup = useSofortPopup<HTMLElement>(p.text);
  if (p.text === "") return null;
  return <span ref={popup} className="kang__version-note">{p.text}</span>;
}
